import React from "react";
import {Link} from "react-router-dom";

import {useConfigCenter} from "core/context/ConfigCenter";
import {MenuButton} from "shared/components/MenuButton";
import {PageType} from "shared/constants/PageType";
import {RouteUrls} from "routing/routing.constants";
import {ReactComponent as PlayButton} from "assets/images/play_button.svg";

import "./Header.scss";

export const Header: React.FC = React.memo(() => {
    const [, {toggleMenuPanel, changePage}] = useConfigCenter();
    const redirectToGame = () => {
        window.open("https://game.neuroborncats.com", "_blank", "noopener,noreferrer");
    }

    return (
        <div className="header">
            <div className="header__title">
                <Link
                    className="ooyoot-logo link"
                    to={RouteUrls.ROOT_URL}
                    onClick={(event) => changePage(PageType.MAIN, undefined, event)}
                />
                <div className="header__title_name">
                    <span>presents:</span>
                    <Link
                        className="game-name link"
                        to={RouteUrls.ROOT_URL}
                        onClick={(event) => changePage(PageType.MAIN, undefined, event)}
                    />
                </div>
            </div>

            <div className="header-actions">
                <PlayButton className="play-button" onClick={redirectToGame}/>
                <div className="header__menu" onClick={toggleMenuPanel}>
                    <MenuButton/>
                </div>
            </div>

        </div>
    );
});
